export default `
// helpers

export const getAttitude = (MBTI)=> MBTI[0]
export const getPreference = (MBTI)=> MBTI[3]
export const getFunctions = (MBTI)=> MBTI[1] + MBTI[2]
export const flipAttitude = (MBTI)=> flip(getAttitude(MBTI))

export const flip = (F)=> {
  F = F.toUpperCase()
  return {
    I: "E",
    E: "I",
    N: "S",
    S: "N",
    F: "T", 
    T: "F",
    J: "P",
    P: "J",
  }[F]
}

export const flipFuncAttitude = (F)=> '{F[0]}{flip(F[1]).toLowerCase()}'

export const mapFunction = (MBTI, flipAttitude=false)=> {
  // function, function, attitude
  MBTI = MBTI.toUpperCase()
  const attitude = (flipAttitude ? flip(getAttitude(MBTI)) : getAttitude(MBTI)).toLowerCase()
  const preference = getPreference(MBTI)
  const map = {
    "Pe": MBTI[1],
    "Pi": MBTI[2],
    "Je": MBTI[2],
    "Ji": MBTI[1],
  }
  const func = map['{preference}{attitude}']
  return '{func}{attitude}'
}

export const getAllFunctions = ()=> ["Se", "Si", "Ne", "Ni", "Te", "Ti", "Fe", "Fi"]

export const getAbsentFunctions = (MBTI)=> {
  const all = getAllFunctions()
  const primary = [ 
    getDominateFunction(MBTI), 
    getAuxililaryFunction(MBTI), 
    getTertiaryFunction(MBTI), 
    getInferiorFunction(MBTI) 
  ]
  return all.filter(f => primary.indexOf(f) < 0 )
}

export const isValidMBTI = (MBTI)=> ":INFP:ESFJ:ESFP:ISFJ:ISFP:ESTJ:ESTP:ISTJ:ISTP:INTJ:INFJ:ENTJ:ENTP:ENFJ:INTP:ENFP:".indexOf(':{MBTI.toUpperCase()}:') > -1

export const getDominateFunction = (MBTI)=> mapFunction(MBTI)
export const getAuxililaryFunction = (MBTI)=> mapFunction(MBTI, true)
export const getTertiaryFunction = (MBTI)=> '{flip(getAuxililaryFunction(MBTI)[0])}{getAttitude(MBTI).toLowerCase()}'
export const getInferiorFunction = (MBTI)=> '{flip(getDominateFunction(MBTI)[0])}{flip(getAttitude(MBTI)).toLowerCase()}'


export const functionKeywords = {
  Ne: ["creative", "visionary"],
  Ti: ["analytical", "objective"],
  Ni: ["strategic", "architecting"],
  Te: ["methodical", "rational"],
  Se: ["scrupulous", "present"],
  Fi: ["empathetic", "poetic"],
  Si: ["pragmatic", "procedural"],
  Fe: ["nurturing", "attentive"],
}


const getFuncOrder = (func)=> Object.keys(functionKeywords).indexOf(func)

export const getTraits = (MBTI)=> {

  const weightTraitsForFunc = (func, s, e)=> {
    let ks = functionKeywords[func]
    const l = ks.length
    return ks.reduce( (list, name, i )=> {
      const p = (l - i) / l
      const weight =  s + ((e - s) * p)
      const order = getFuncOrder(func) + p
      list.push({name, weight, func, order})
      return list
    }, [])
  }

  const d = getDominateFunction(MBTI)
  const df = flipFuncAttitude(d)

  let funcs = [
    { f: getDominateFunction(MBTI), r: [.9,1]},
    { f: getAuxililaryFunction(MBTI), r: [.6, .8]},
    { f: getTertiaryFunction(MBTI), r: [.3, .4]},
    { f: getInferiorFunction(MBTI), r: [.2, .3]},
  ]

  // add in ancillary funcs diminisiond slightly
  funcs = funcs.reduce( (funcs, func)=>{
    return funcs.concat({ f: flipFuncAttitude(func.f), r: [func.r[0]-.1, func.r[1] - .1] })
  }, funcs)

  return funcs.reduce( (list, func)=>{
    return list.concat(weightTraitsForFunc(func.f, func.r[0], func.r[1]))
  }, []).sort( (a,b)=> a.order > b.order ? 1 : -1 )
}


import { 
  getDominateFunction, 
  getAuxililaryFunction, 
  getTertiaryFunction, 
  getInferiorFunction,
  getAbsentFunctions,
  getAllFunctions,
  getTraits,
  isValidMBTI,
  functionKeywords, 
} from "./functions"


// // http://materialuicolors.co/
// blue, green, red
const colors = ["#80D8FF", "#69F0AE", "#FF5252"]

export default {
  order: 0,
  name: "Mark Johnson",
  mbti: "INTP",
  get valid() {
    // todo: make more valid
    return this.mbti.length === 4
  },
  get color() {
    return colors[this.order] || "red"
  },
  get funcs() {
    return [
      getDominateFunction(this.mbti),
      getAuxililaryFunction(this.mbti),
      getTertiaryFunction(this.mbti),
      getInferiorFunction(this.mbti),
    ]
  },
  get attributes() {
    return getTraits(this.mbti)
  },
  get chartTraits() {
    return this.attributes.map( a=> { return {axis: a.name, value: a.weight} })
  },
  isValidMBTI(mbti) {
    return isValidMBTI(mbti)
  },
}




/////////////////////////////////////////////////////////
/////////////// The Radar Chart Function ////////////////
/////////////// Written by Nadieh Bremer ////////////////
////////////////// VisualCinnamon.com ///////////////////
/////////// Inspired by the code of alangrafu ///////////
/////////////////////////////////////////////////////////
// 85,151,175 - Dot color

import * as d3 from "d3"

export const drawRadarChart = (props)=> {
  let { data, options } = props
  const node = document.createElement('div')

  props = {
    w: 450, //Width of the circle
    h: 450, //Height of the circle
    margin: {
      top: 20,
      right: 100,
      bottom: 20,
      left: 100
    }, //The margins of the SVG
    levels: 20, //How many levels or inner circles should there be drawn
    opacityArea: 0.1, //The opacity of the area of the blob
    dotRadius: 4, //The size of the colored circles of each blog
    opacityCircles: 0.0, //The opacity of the circles of each blob
    strokeWidth: 1, //The width of the stroke around each blob
    color: d3.scaleOrdinal().range(["#3c8aba"])
  , ...options}

  // adjust width/height to behave like border-box
  props.w = props.w - (props.margin.left + props.margin.right)
  props.h = props.h - (props.margin.top + props.margin.bottom)

  const allAxis = (data[0].chart.map(function(i, j) {
      return i.axis.toUpperCase()
    })), //Names of each axis
    total = allAxis.length, //The number of different axes
    radius = Math.min(props.w / 2, props.h / 2), //Radius of the outermost circle
    angleSlice = Math.PI * 2 / total //The width in radians of each "slice"

  const rScale = d3.scaleLinear()
    .range([1, radius])
    .domain([0, 1])

  /////////////////////////////////////////////////////////
  //////////// Create the node SVG and g /////////////
  /////////////////////////////////////////////////////////

  //Remove whatever chart with the same id/class was present before
  d3.select(node).select("svg").remove()

  //Initiate the radar chart SVG
  const svg = d3.select(node).append("svg")
    .attr("width", props.w + props.margin.left + props.margin.right)
    .attr("height", props.h + props.margin.top + props.margin.bottom)
    .attr("class", "radar-chart")
  
  //Append a g element  
  const g = svg.append("g")
    .attr("transform", "translate(" + (props.w / 2 + props.margin.left) + "," + (props.h / 2 + props.margin.top) + ")")

  /////////////////////////////////////////////////////////
  ////////// Glow filter for some extra pizzazz ///////////
  /////////////////////////////////////////////////////////

  //Filter for the outside glow
  const filter = g.append('defs').append('filter').attr('id', 'glow'),
    feGaussianBlur = filter.append('feGaussianBlur').attr('stdDeviation', '2').attr('result', 'coloredBlur'),
    feMerge = filter.append('feMerge'),
    feMergeNode_1 = feMerge.append('feMergeNode').attr('in', 'coloredBlur'),
    feMergeNode_2 = feMerge.append('feMergeNode').attr('in', 'SourceGraphic')

  /////////////////////////////////////////////////////////
  /////////////// Draw the Circular grid //////////////////
  /////////////////////////////////////////////////////////

  //Wrapper for the grid & axes
  const axisGrid = g.append("g").attr("class", "axisWrapper")

  //Draw the background circles
  axisGrid.selectAll(".levels")
    .data(d3.range(1, (props.levels + 1)).reverse())
    .enter()
    .append("circle")
    .attr("class", "gridCircle")
    .attr("r", function(d, i) {
      return radius / props.levels * d
    })
    .style("stroke", "#435865")
    .style("fill-opacity", props.opacityCircles)


  /////////////////////////////////////////////////////////
  //////////////////// Draw the axes //////////////////////
  /////////////////////////////////////////////////////////

  //Create the straight lines radiating outward from the center
  const axis = axisGrid.selectAll(".axis")
    .data(allAxis)
    .enter()
    .append("g")
    .attr("class", "axis")
  //Append the lines
  axis.append("line")
    .attr("x1", 0)
    .attr("y1", 0)
    .attr("x2", function(d, i) {
      return rScale(1) * Math.cos(angleSlice * i - Math.PI / 2)
    })
    .attr("y2", function(d, i) {
      return rScale(1) * Math.sin(angleSlice * i - Math.PI / 2)
    })
    .attr("class", "line")
    .style("stroke", "#628194")
    .style("stroke-width", props.strokeWidth)

  //Append the labels at each axis
  axis.append("text")
    .attr("class", "legend")
    .style("font-size", "12px")
    .attr("fill", props.color)
    .attr("text-anchor", function(d, i) {
      const pos = Math.round(rScale(1) * Math.cos(angleSlice * i - Math.PI / 2))
      if (pos === 0) {
        return "middle"
      } else if (pos > 0) {
        return "start"
      } else {
        return "end"
      }
    })
    //manually tweak the label positions kinda hacky
    .attr("dy", function(d, i) {
      if (i === 0) {
        // top
        return "-10px"
      } else if (i === 8) {
        // bottom
        return "20px"
      } else if (i === 1 || i === 15) {
        return "-3px"
      } else if (i === 9 || i === 11) {
        // 5/7oclock
        return "10px"
      } else {
        // general bump
        return "3px"
      }
    })
    .attr("dx", function(d, i) {
      const pos = Math.round(rScale(1) * Math.cos(angleSlice * i - Math.PI / 2))
      if (pos === 0) {
        return "0px"
      } else if (pos > 0) {
        return "10px"
      } else {
        return "-10px"
      }
    })
    .attr("x", function(d, i) {
      return rScale(1) * Math.cos(angleSlice * i - Math.PI / 2)
    })
    .attr("y", function(d, i) {
      return rScale(1) * Math.sin(angleSlice * i - Math.PI / 2)
    })
    .text(function(d) {
      return d
    })

  // These are the circles on the outside parimiter.
  axis.append("circle")
    .attr("class", "radarEndCircle")
    .attr("r", props.dotRadius * 1.1)
    .attr("cx", function(d, i) {
      return rScale(1) * Math.cos(angleSlice * i - Math.PI / 2)
    })
    .attr("cy", function(d, i) {
      return rScale(1) * Math.sin(angleSlice * i - Math.PI / 2)
    })
    .style("stroke", "#3c8aba")
    .style("stroke-width", "2px")
    .style("fill", "#33434d")

  // Inner circle
  axis.append("circle")
    .attr("class", "innerCircle")
    .attr("r", 20)
    .style("stroke", "#3c8aba")
    .style("stroke-width", "2px")
    .style("fill", "#33434d")

  /////////////////////////////////////////////////////////
  ///////////// Draw the radar chart blobs ////////////////
  /////////////////////////////////////////////////////////

  //The radial line function
  const radarLine = d3.radialLine()
    .curve(d3.curveLinearClosed)
    .radius(function(d) {
      return rScale(d.value)
    })
    .angle(function(d, i) {
      return i * angleSlice
    })

  //Create a wrapper for the blobs 

  const createRadarBlob = (data, i)=> {

    const { chart, color } = data

    const blobWrapper = g.selectAll(".radarWrapper")
      .data([chart])
      .enter().append("g")
      .attr("class", 'radarWrapper-{i}')

    //Append the backgrounds  
    const areaCls = 'radarArea-{i}'
    blobWrapper
      .append("path")
      .attr("class", "radarArea")
      .attr("d", function(d, i) {
        return radarLine(d)
      })
      .style("fill", function(d, i) {
        return color
      })
      .style("fill-opacity", props.opacityArea)
      .on('mouseover', function(d, i) {
        //Dim all blobs
        d3.selectAll(".radarArea")
          .transition().duration(0)
          .style("fill-opacity", props.opacityArea - .05)
        //Bring back the hovered over blob
        d3.select(this)
          .transition().duration(0)
          .style("fill-opacity", props.opacityArea + .1)
      })
      .on('mouseout', function() {
        //Bring back all blobs
        d3.selectAll(".radarArea")
          .transition().duration(0)
          .style("fill-opacity", props.opacityArea)
      })



    //Create the outlines 
    blobWrapper.append("path")
      .attr("class", "radarStroke")
      .attr("d", function(d, i) {
        return radarLine(d)
      })
      .style("stroke-width", props.strokeWidth + "px")
      .style("stroke", function(d, i) {
        return color
      })
      .style("fill", "none")
      .style("filter", "url(#glow)")


    //Append the circles
    blobWrapper.selectAll(".radarCircle")
      .data(function(d, i) {
        return d
      })
      .enter().append("circle")
      .attr("class", "radarCircle")
      .attr("r", 2)
      .attr("cx", function(d, i) {
        return rScale(d.value) * Math.cos(angleSlice * i - Math.PI / 2)
      })
      .attr("cy", function(d, i) {
        return rScale(d.value) * Math.sin(angleSlice * i - Math.PI / 2)
      })
      .style("fill", function(d, i, j) {
        return "white"
      })
      .style("fill-opacity", 0.8)

  }

  data.map(createRadarBlob)

  return node
}
`


// WEBPACK FOOTER //
// ./src/data/code.js